<div class="configurationContainer ">
    <!-- <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span> -->
   <div class="loader" *ngIf="bodySpinner"></div>
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">Configuration</span></h5>
        </div>
        <div class="col px-0">
       </div>
    </div>
    </div>
      <div class="container-fluid align-items-start configContents">
    <div class="row">
      <div class="col-md-2 configTab">
        <ul class="nav flex-column nav-pills nav-justified" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <!-- <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='rfp'}" (click)="showTriangle('rfp')">
            <a class="nav-link active tabBtn" id="v-pills-rfp-tab" data-bs-toggle="tab" data-bs-target="#v-pills-rfp"
              type="button" role="tab" aria-controls="v-pills-rfp" aria-selected="true">RFP Type</a>
          </li> -->
          <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='company'}" (click)="showTriangle('company')">
            <a class="nav-link active" id="v-pills-company-tab" data-bs-toggle="tab" data-bs-target="#v-pills-company"
              type="button" role="tab" aria-controls="v-pills-company" aria-selected="true">Company Management</a>
          </li>
           <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='relationship'}" (click)="showTriangle('relationship')">
            <a class="nav-link" id="v-pills-relationship-tab" data-bs-toggle="tab" data-bs-target="#v-pills-relationship"
              type="button" role="tab" aria-controls="v-pills-relationship" aria-selected="true">Relationship</a>
          </li>
           <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='lob'}" (click)="showTriangle('lob')">
            <a class="nav-link" id="v-pills-lob-tab" data-bs-toggle="tab" data-bs-target="#v-pills-lob"
              type="button" role="tab" aria-controls="v-pills-lob" aria-selected="true">Line of Business</a>
          </li>
           <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='siccode'}" (click)="showTriangle('siccode')">
            <a class="nav-link" id="v-pills-siccode-tab" data-bs-toggle="tab" data-bs-target="#v-pills-siccode"
              type="button" role="tab" aria-controls="v-pills-siccode" aria-selected="true">SIC Code</a>
          </li>
          </ul>
       </div>
        <div class="col-md-8 tableTab">
            <div class="tab-content" id="v-pills-tabContent">
              
         
             <div class="tab-pane fade show active" [ngClass]="{'active':tabTriangle==='company'}" id="v-pills-company" role="tabpanel" aria-labelledby="v-pills-company-tab">
                <div class="card">
                  <div class="card-body">
                    <div class="tblHead d-flex border-bottom">
                      <div class="firstPart">
                        <h4>Company Details
                          <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                          <span class="sr-only">Loading...</span>
                        </h4>
                      </div>
                      <div class="secondPart">
                        @if(currentUserDetail?.role=="Admin"){
                         <!-- <i class="fa-solid fa-square-plus plusIcon" (click)="exitIconReset()"   data-bs-toggle="modal"
                          data-bs-target="#companyDetails" tooltip="Create New Company" [options]="myOptions"></i> -->
                           <i class="fa-solid fa-square-plus plusIcon" (click)="OpenModal('company','new')" tooltip="Create New Company" [options]="myOptions"></i>
                          
                       }
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table ">
                        <thead class="tblHeadings">
                          <tr>
                            <th>Company Name</th>
                            <th>Company Relationship</th>
                            <th>Contact Person</th>
                            <th>Contact Email</th>
                            <th>LOB</th>
                            <th>Details</th>
                            <th>Status</th>
                             <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                        <tr class="text-center" *ngIf="companyListData.length === 0">
                            <td colspan="10" *ngIf="!bodySpinner">
                              <p class="noRecord">No Records Found</p>
                          </tr> 
                             @for(company of companyListData; track company.id;let idx = $index){
                          <tr class="topicKeywordTable">
                            <td>{{company.company_name}}</td>
                            <td>
                                @for(relastion of companyRelationshipList; track relastion.id;let idx = $index){
                               @if(company.company_relationship_id==relastion.id){
                                {{relastion.relationship_name}}
                               }
                                }
                            </td>
                            <td>{{company?.contact_person}}</td>
                            <td>{{company?.contact_email}}</td>
                             <td>
                               <ng-container *ngIf="company?.lob_ids.length==0">
                                -
                              </ng-container>
                              <ng-container *ngIf="company?.lob_ids.length > 0">
                                {{getLOBName(company?.lob_ids)}}
                              </ng-container>
                             </td>
                            <td><p [innerHTML]="company?.company_details"></p></td>
                            <td>{{company.is_active ? 'Active' : 'InActive'}}</td>
                            <td> <span class="icons">
                              <!-- <i data-bs-toggle="modal"
                          data-bs-target="#companyDetails" (click)="selectCompany(idx)"  class="bi bi-pencil-square"></i> -->
                          
                          @if(currentUserDetail?.role=="Admin"){  
                            <span class="icon" tooltip="Edit" [options]="myOptions"> <i   (click)="selectCompany(company)"  class="bi bi-pencil-square"></i></span>
                          <span class="icon" tooltip="Delete" [options]="myOptions">  <i class="bi bi-trash" (click)="deleteCompany(company.id)"></i></span>
                          }
                        </span></td>
                          </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
               <div class="tab-pane fade" [ngClass]="{'active':tabTriangle==='relationship'}" id="v-pills-relationship" role="tabpanel" aria-labelledby="v-pills-relationship-tab">
                <div class="card">
                  <div class="card-body">
                    <div class="tblHead d-flex border-bottom">
                      <div class="firstPart">
                        <h4>Relationship Details
                          <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                          <span class="sr-only">Loading...</span>
                        </h4>
                      </div>
                      <div class="secondPart">
                        @if(currentUserDetail?.role=="Admin"){
                        <i class="fa-solid fa-square-plus plusIcon" (click)="OpenModal('relationship','new')" tooltip="Create New Relationship" [options]="myOptions"></i>
                        }
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <thead class="tblHeadings">
                          <tr>
                        
                            <th>Relationship</th>
                            <th>Description</th>
                           
                            <th>Status</th>
                             <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                           <tr class="text-center" *ngIf="companyRelationshipList.length === 0 && !spinner">
                            <td colspan="10" *ngIf="!bodySpinner">
                              <p class="noRecord">No Records Found</p>
                          </tr> 
                          @for(relastion of companyRelationshipList; track relastion.id;let idx = $index){
                          <tr class="topicKeywordTable">
                            <td>{{relastion.relationship_name}}</td>
                            <td>{{relastion.description}}</td>
                            <td>{{relastion.is_active ? 'Active' : 'InActive'}}</td>
                            <td> <span class="icons">
                              
                          @if(currentUserDetail?.role=="Admin"){  
                            <span class="icon" tooltip="Edit" [options]="myOptions"><i  (click)="selectRelationship(relastion)"  class="bi bi-pencil-square"></i></span>
                         <span class="icon" tooltip="Delete" [options]="myOptions"> <i class="bi bi-trash" (click)="deleteRelationship(relastion.id)"></i></span>
                          }
                        </span></td>
                          </tr>
                          }
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" [ngClass]="{'active':tabTriangle==='lob'}" id="v-pills-lob" role="tabpanel" aria-labelledby="v-pills-lob-tab">
                <div class="card">
                  <div class="card-body">
                    <div class="tblHead d-flex border-bottom">
                      <div class="firstPart">
                        <h4>Line Of Business Details
                          <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                          <span class="sr-only">Loading...</span>
                        </h4>
                      </div>
                      <div class="secondPart">
                        @if(currentUserDetail?.role=="Admin"){
                        <i class="fa-solid fa-square-plus plusIcon" (click)="OpenModal('lob','new')" tooltip="Create New Line Of Business" [options]="myOptions"></i>
                        }
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <thead class="tblHeadings">
                          <tr>
                        
                            <th>Name</th>
                            <th>Description</th>
                           
                            <th>Status</th>
                             <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                           <tr class="text-center" *ngIf="lobListData.length === 0 && !spinner">
                            <td colspan="10" *ngIf="!bodySpinner">
                              <p class="noRecord">No Records Found</p>
                          </tr> 
                          @for(lob of lobListData; track lob.id;let idx = $index){
                          <tr class="topicKeywordTable">
                            <td>{{lob.lob_name}}</td>
                            <td>{{lob.description}}</td>
                            <td>{{lob.is_active ? 'Active' : 'InActive'}}</td>
                            <td> <span class="icons">
                             
                          @if(currentUserDetail?.role=="Admin"){  
                             <span class="icon" tooltip="Edit" [options]="myOptions"><i  (click)="selectLob(lob)"  class="bi bi-pencil-square"></i></span>
                            <span class="icon" tooltip="Delete" [options]="myOptions"> <i class="bi bi-trash"  (click)="deleteLOB(lob.id)"></i></span>
                          }
                        </span></td>
                          </tr>
                          }
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" [ngClass]="{'active':tabTriangle==='siccode'}" id="v-pills-siccode" role="tabpanel" aria-labelledby="v-pills-siccode-tab">
                <div class="card">
                  <div class="card-body">
                    <div class="tblHead d-flex border-bottom">
                      <div class="firstPart">
                        <h4>SIC Code Details
                          <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                          <span class="sr-only">Loading...</span>
                        </h4>
                      </div>
                      <div class="secondPart">
                    @if(currentUserDetail?.role=="Admin"){    
                        <i class="fa-solid fa-square-plus plusIcon" (click)="OpenModal('sic','new')" tooltip="Create New SIC Code" [options]="myOptions"></i>
                    }
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <thead class="tblHeadings">
                          <tr>
                           <th>Title</th>
                            <th>SIC</th>
                            <th>Description</th>
                           
                            <th>Status</th>
                             <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                           <tr class="text-center" *ngIf="sicListData.length === 0 && !spinner">
                            <td colspan="10" *ngIf="!bodySpinner">
                              <p class="noRecord">No Records Found</p>
                          </tr> 
                          @for(sic of sicListData; track sic.id;let idx = $index){
                          <tr class="topicKeywordTable">
                            <td>{{sic.sic_title}}</td>
                            <td>{{sic.sic_code}}</td>
                            <td>{{sic.description}}</td>
                            <td>{{sic.is_active ? 'Active' : 'InActive'}}</td>
                            <td>
                               <span class="icons">
                              
                         @if(currentUserDetail?.role=="Admin"){  
                           <span class="icon" tooltip="Edit" [options]="myOptions"><i  (click)="selectSICCode(sic)"  class="bi bi-pencil-square"></i></span> 
                          <span class="icon" tooltip="Delete" [options]="myOptions"><i class="bi bi-trash" (click)="deleteSIC(sic.id)"></i></span>
                         }
                        </span></td>
                          </tr>
                          }
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            
            </div>
        </div>
    </div>      
</div>   

  <!--RFP form modal window 
        <div class="modal fade topicFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="rfpDetails"
        #topicModal>
        <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title">RFP</h4>
            <span>
                <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()"></i>
            </span>
            
            </div>
            <div><i *ngIf="spinner"
            class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
            </div>
            <div class="modal-body" *ngIf="!spinner">
            <div class="col">
                <form class="rfpconfigFrom" [formGroup]="rfpconfigFrom" autocomplete="off">
           
                <div class="row">
                  <div class="col-3">
                    <label for="topic" class="form-label mandatoryLabel">RFP Type
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                    <div class="col">
                    <input type="text" class="form-control" formControlName="rfp_name" id="rfp_name" name="rfp_name"
                    placeholder="Enter Your RFP Type" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && rfpconfigFrom.hasError('required','rfp_name') ">RFP Type is
                    required.
                    </span>
                    </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <label for="topic" class="form-label mandatoryLabel">RFP Description
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    </div>
                    <div class="col">
                    <textarea class="form-control" formControlName="description"></textarea>
                        <span class="text-danger"
                    *ngIf="submitted && rfpconfigFrom.hasError('required','description')">RFP description is
                    required.
                    </span>
                  </div>
                </div>
                  <div class="row">
                    <div class="col-3">Active</div>
                    <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active">&nbsp;</label>
                                            <input class="form-check-input" type="checkbox" formControlName="rfp_active"
                                            name="active" id="active">
                                        </div>

                                         <span class="text-danger"
                    *ngIf="submitted && rfpconfigFrom.hasError('required','rfp_active')">RFP description is
                    required.
                    </span>
                  </div>
                 </div>
                </form>
            </div>

            </div>
        
            <div class="modal-footer" *ngIf="!spinner">
            <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveCompany()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateForm()">Update</button>
                </ng-container>
            </div>
            </div>
        
        </div>
        </div>
        </div>-->

  <!--Company form modal window -->
        <!-- <div class="modal fade topicFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="companyDetails"
        #topicModal>
        <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title">Company Details</h4>
            <span>
                <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()"></i>
            </span>
            
            </div>
            <div><i *ngIf="spinner"
            class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
            </div>
            <div class="modal-body" *ngIf="!spinner">
            <div class="col">
                <form class="companyconfigFrom" [formGroup]="companyconfigFrom" autocomplete="off">
         
                <div class="row">
                  <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Company Name
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" formControlName="company_name" id="company_name" name="company_name"
                    placeholder="Enter Your Company Name" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','company_name') ">Company Name is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.controls['company_name'].value !='' && companyconfigFrom.controls['company_name'].hasError('pattern')">Enter valid company name
                    </span>
                    </div>
                    <div class="col">
                        <label for="topic" class="form-label mandatoryLabel">Company Relationship
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
               
                      <ng-select  placeholder="Select" formControlName="company_relationship_id" name="company_relationship_id" id="company_relationship_id"
                                class="transcribeClass">
                                    @for (items of companyRelationshipList; track items.id) {
                                        <ng-option [value]="items.id">{{items?.relationship_name}}</ng-option>
                                    }
                                </ng-select>
             
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','company_relationship_id') ">Company Relationship is
                    required.
                    </span>
                    </div>
                </div>
               
            
                
                 <div class="row">
                  <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Company Details
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <textarea class="form-control" formControlName="company_details"></textarea>
                        <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','company_details')">Company Details is
                    required.
                    </span>
                     <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.controls['company_details'].value !='' && companyconfigFrom.controls['company_details'].hasError('pattern')">Enter valid company details
                    </span>
                  </div>
                <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Contact Person 
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" formControlName="contact_person" id="contact_person" name="contact_person"
                    placeholder="Enter Your Contact Person Name" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','contact_person') ">Contact Person is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.controls['contact_person'].value !='' && companyconfigFrom.controls['contact_person'].hasError('pattern')">Enter valid person name
                    </span>
                </div>
                </div>
                    <div class="row">
                      <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Contact Number
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" formControlName="contact_number" id="contact_number" name="contact_number"
                    placeholder="Enter Your Contact Number" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','contact_number') ">Contact Number is
                    required.
                    </span>
                    </div>
                
                    <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Contact Email
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" formControlName="contact_email" id="contact_email" name="contact_email"
                    placeholder="Enter Your Contact Email" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','contact_email') ">Contact Email is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.controls['contact_email'].value!='' && companyconfigFrom.controls['contact_email'].hasError('pattern') ">Enter valid email
                    </span>
                     </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Line Of Business
                    </label>
                         <ng-select  placeholder="Select" [multiple]="true" [maxSelectedItems]="1" formControlName="lob_ids" name="lob_ids" id="lob_ids"
                                class="transcribeClass">
                                    @for (lob of lobListData; track lob.id) {
                                        <ng-option [value]="lob.id">{{lob.lob_name}}</ng-option>
                                    }
                                </ng-select>
                                  <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','lob_ids') ">Line Of Business is
                    required.
                    </span>
                  </div>
                  <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">SIC Code
                     </label>
                         <ng-select  placeholder="Select" [multiple]="true" [maxSelectedItems]="1" formControlName="sic_ids" name="sic_ids" id="sic_ids"
                                class="transcribeClass">
                                    @for (sic of sicListData; track sic.id) {
                                        <ng-option [value]="sic.id">{{sic.sic_code}}</ng-option>
                                    }
                                </ng-select>
                                      <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','sic_ids') ">SIC Code is
                    required.
                    </span>
                  </div>
                </div>
                <div class="row">
                   <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active">Active</label>
                                            <input class="form-check-input" type="checkbox" formControlName="is_active"
                                            name="is_active" id="active">
                                        </div>
                                         <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','is_active')">Company active is
                    required.
                    </span>
                    </div>
                  </div>

                </form>
            </div>

            </div>
        
            <div class="modal-footer" *ngIf="!spinner">
            <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveCompany()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateForm()">Update</button>
                </ng-container>
            </div>
            </div>
        
        </div>
        </div>
        </div> -->


          <!--Relationship form modal window -->
        <div class="modal fade topicFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="relationshipDetails"
        #topicModal>
        <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title">Relationship Details</h4>
            <span>
                <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()"></i>
            </span>
            
            </div>
            <div><i *ngIf="spinner"
            class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
            </div>
            <div class="modal-body" *ngIf="!spinner">
            <div class="col">
                <form class="companyconfigFrom" [formGroup]="relationshipconfigFrom" autocomplete="off">
         
                <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Relationship Type
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" formControlName="relationship_name" id="relationship_name" name="relationship_name"
                    placeholder="Enter Relationship Type" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.hasError('required','relationship_name') ">Relationship Type is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.controls['relationship_name'].value!='' && relationshipconfigFrom.controls['relationship_name'].hasError('pattern') ">Enter valid relationship type.
                    </span>
                    </div>
                   
                </div>
                <div class="row"> 
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Description
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                   <div class="col">
                      
             
                    
                 <textarea class="form-control" formControlName="description" id="description" name="description"></textarea>
                    <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.hasError('required','description') ">Description is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.controls['description'].value !='' && relationshipconfigFrom.controls['description'].hasError('pattern')">Enter valid description
                    </span>
                    </div>
                </div>
               
            
                
                 
                
                
                <div class="row">
                   <div class="col-3">  <label  class="form-label mandatoryLabel">Active
                     </label></div>
                   <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active"></label>
                                            <input class="form-check-input" type="checkbox" formControlName="is_active"
                                            name="is_active" id="active">
                                        </div>
                                         <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.hasError('required','is_active')">Status is
                    required.
                    </span>
                    </div>
                  </div>

                </form>
            </div>

            </div>
        
            <div class="modal-footer" *ngIf="!spinner">
            <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveRelationship()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateRelationshipForm()">Update</button>
                </ng-container>
            </div>
            </div>
        
        </div>
        </div>
        </div>


           <!--Line of Business form modal window -->
        <div class="modal fade topicFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="lobDetails"
        #topicModal>
        <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title">Line of Business Details</h4>
            <span>
                <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()"></i>
            </span>
            
            </div>
            <div><i *ngIf="spinner"
            class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
            </div>
            <div class="modal-body" *ngIf="!spinner">
            <div class="col">
                <form class="companyconfigFrom" [formGroup]="lobconfigFrom" autocomplete="off">
         
                <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Name
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" formControlName="lob_name" id="lob_name" name="lob_name"
                    placeholder="Enter LOB Name" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.hasError('required','lob_name') ">Name is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.controls['lob_name'].value!='' && lobconfigFrom.controls['lob_name'].hasError('pattern') ">Enter valid name.
                    </span>
                    </div>
                   
                </div>
                <div class="row"> 
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Description
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                   <div class="col">
                      
             
                    
                 <textarea class="form-control" formControlName="description" id="description" name="description"></textarea>
                    <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.hasError('required','description') ">Description is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.controls['description'].value !='' && lobconfigFrom.controls['description'].hasError('pattern')">Enter valid description
                    </span>
                    </div>
                </div>
               
            
                
                 
                
                
                <div class="row">
                   <div class="col-3">  <label  class="form-label mandatoryLabel">Active
                     </label></div>
                   <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active"></label>
                                            <input class="form-check-input" type="checkbox" formControlName="is_active"
                                            name="is_active" id="active">
                                        </div>
                                         <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.hasError('required','is_active')">Status is
                    required.
                    </span>
                    </div>
                  </div>

                </form>
            </div>

            </div>
        
            <div class="modal-footer" *ngIf="!spinner">
            <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveLOB()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateLOB()">Update</button>
                </ng-container>
            </div>
            </div>
        
        </div>
        </div>
        </div>


        
           <!--SIC Code form modal window -->
        <div class="modal fade topicFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="sicCodeDetails"
        #topicModal>
        <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title">SIC Code Details</h4>
            <span>
                <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()"></i>
            </span>
            
            </div>
            <div><i *ngIf="spinner"
            class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
            </div>
            <div class="modal-body" *ngIf="!spinner">
            <div class="col">
                <form class="companyconfigFrom" [formGroup]="sicCodeconfigFrom" autocomplete="off">
         
              
                <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Title
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" formControlName="sic_title" id="sic_title" name="sic_title"
                    placeholder="Enter Title" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','sic_title') ">Title is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.controls['sic_title'].value!='' && sicCodeconfigFrom.controls['sic_title'].hasError('pattern') ">Enter valid data.
                    </span>
                    </div>
                   
                </div>
                  <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">SIC Code
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" formControlName="sic_code" id="sic_code" name="sic_code"
                    placeholder="Enter SIC Code" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','sic_code') ">SIC Code is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.controls['sic_code'].value!='' && sicCodeconfigFrom.controls['sic_code'].hasError('pattern') ">Enter valid data.
                    </span>
                    </div>
                   
                </div>
                 <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">SIC Office
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" formControlName="sic_office" id="sic_office" name="sic_office"
                    placeholder="Enter Office" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','sic_office') ">SIC Office is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.controls['sic_office'].value!='' && sicCodeconfigFrom.controls['sic_office'].hasError('pattern') ">Enter valid data.
                    </span>
                    </div>
                   
                </div>
                <div class="row"> 
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Description
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                   <div class="col">
                      
             
                    
                 <textarea class="form-control" formControlName="description" id="description" name="description"></textarea>
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','description') ">Description is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.controls['description'].value !='' && sicCodeconfigFrom.controls['description'].hasError('pattern')">Enter valid description
                    </span>
                    </div>
                </div>
               
            
                
                 
                
                
                <div class="row">
                   <div class="col-3">  <label  class="form-label mandatoryLabel">Active
                     </label></div>
                   <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active"></label>
                                            <input class="form-check-input" type="checkbox" formControlName="is_active"
                                            name="is_active" id="active">
                                        </div>
                                         <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','is_active')">Status is
                    required.
                    </span>
                    </div>
                  </div>

                </form>
            </div>

            </div>
        
            <div class="modal-footer" *ngIf="!spinner">
            <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveSICCode()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateSICCode()">Update</button>
                </ng-container>
            </div>
            </div>
        
        </div>
        </div>
        </div>

         <!-- Delete Modal Window -->
<div class="modal fade deleteModal" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel"  aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
                        <div class="modal-header">
                        <h4 class="modal-title" id="deleteModalLabel">Delete Relationship</h4>
                        <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
                        </div>
                        <div class="modal-body">
                        Are you sure you want to delete?
                        </div>
                        <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                        <button type="button" class="btn btn-danger" (click)="deleteRelationship(selectedRelationshipId)"
                            data-bs-dismiss="modal">Yes</button>
                        </div>
        </div>
    </div>
</div>
         <!-- Delete Company Modal Window -->
<div class="modal fade deleteModal" id="deleteCompanyModal" tabindex="-1" aria-labelledby="deleteModalLabel"  aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
                        <div class="modal-header">
                        <h4 class="modal-title" id="deleteModalLabel">Delete Company</h4>
                        <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
                        </div>
                        <div class="modal-body">
                        Are you sure you want to delete?
                        </div>
                        <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                        <button type="button" class="btn btn-danger" (click)="deleteCompany(selectedCompanyId)"
                            data-bs-dismiss="modal">Yes</button>
                        </div>
        </div>
    </div>
</div>

         <!-- Delete Company Modal Window -->
<div class="modal fade deleteModal" id="deleteLOBModal" tabindex="-1" aria-labelledby="deleteModalLabel"  aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
                        <div class="modal-header">
                        <h4 class="modal-title" id="deleteModalLabel">Delete Line Of Business</h4>
                        <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
                        </div>
                        <div class="modal-body">
                        Are you sure you want to delete?
                        </div>
                        <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                        <button type="button" class="btn btn-danger" (click)="deleteLOB(selectedLobId)"
                            data-bs-dismiss="modal">Yes</button>
                        </div>
        </div>
    </div>
</div>

         <!-- Delete SIC Modal Window -->
<div class="modal fade deleteModal" id="deleteSICModal" tabindex="-1" aria-labelledby="deleteModalLabel"  aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
                        <div class="modal-header">
                        <h4 class="modal-title" id="deleteModalLabel">Delete SIC</h4>
                        <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
                        </div>
                        <div class="modal-body">
                        Are you sure you want to delete?
                        </div>
                        <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                        <button type="button" class="btn btn-danger" (click)="deleteSIC(selectedSicId)"
                            data-bs-dismiss="modal">Yes</button>
                        </div>
        </div>
    </div>
</div>

<app-dialog-modal [isVisible]="isModalVisible" [popLoader]="popLoader" [size]="metricFullscreen ? 'full-screen' :'large'">
  <div modal-header class="modal-header">
     <h4 class="modal-title">
      <ng-container *ngIf="seletedModal=='company'">
        Company Details
      </ng-container>
       <ng-container *ngIf="seletedModal=='relationship'">
        Relationship Details
       </ng-container>
       <ng-container *ngIf="seletedModal=='lob'">
        Line of Business Details
       </ng-container>
       <ng-container *ngIf="seletedModal=='sic'">
        SIC Code Details
       </ng-container>
    </h4>
     <span>
                <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
                (click)="closeModal()"></i>
            </span>
  </div>
  <div modal-body class="modal-body">
     <ng-container *ngIf="seletedModal=='company'">
        <div class="col">
                <form class="companyconfigFrom" [formGroup]="companyconfigFrom" autocomplete="off">
         
                <div class="row">
                  <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Company Name
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" TrimText formControlName="company_name" id="company_name" name="company_name"
                    placeholder="Enter Your Company Name" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','company_name') ">Company Name is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.get('company_name')?.value !='' && companyconfigFrom.controls['company_name'].hasError('pattern')">
                    Invalid input: Only special characters (space, &, -) are allowed.
                    </span>
                    </div>
                    <div class="col">
                        <label for="topic" class="form-label mandatoryLabel">Company Relationship
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <!-- <input type="text" class="form-control" formControlName="company_relationship" id="company_relationship" name="company_relationship"
                    placeholder="Enter Your Company Relationship" autocomplete="off"> -->
                      <ng-select  placeholder="Select" formControlName="company_relationship_id" name="company_relationship_id" id="company_relationship_id"
                                class="transcribeClass">
                                    @for (items of companyRelationshipList; track items.id) {
                                        <ng-option [value]="items.id">{{items?.relationship_name}}</ng-option>
                                    }
                                </ng-select>
                 <!-- <select formControlName="company_relationship_id" id="company_relationship_id" name="company_relationship_id">
                  <option value="">Select</option>
                  <option *ngFor="let items of companyRelationshipList" value="{{items.id}}">{{items?.relationship_name}}</option>
                </select>  -->
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','company_relationship_id') ">Company Relationship is
                    required.
                    </span>
                    </div>
                </div>
               
            
                
                 <div class="row">
                  <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Company Details
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <textarea class="form-control" TrimText formControlName="company_details"></textarea>
                        <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','company_details')">Company Details is
                    required.
                    </span>
                     <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.controls['company_details'].value !='' && companyconfigFrom.controls['company_details'].hasError('pattern')">
                    Invalid input: Only special characters (space, &, comma, -, ') are allowed.
                    </span>
                  </div>
                <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Contact Person 
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" TrimText formControlName="contact_person" id="contact_person" name="contact_person"
                    placeholder="Enter Your Contact Person Name" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','contact_person') ">Contact Person is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.controls['contact_person'].value !='' && companyconfigFrom.controls['contact_person'].hasError('pattern')">
                    Invalid input: Only special characters (space, &) are allowed.
                    </span>
                </div>
                </div>
                    <div class="row">
                      <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Contact Number
                    </label>
                    <app-phone-number-input #phoneComp formControlName="contact_number"
                      [isInvalid]="(submitted || companyconfigFrom.controls['contact_number'].touched) && !!companyconfigFrom.controls['contact_number'].errors"
                      [parentErrors]="companyconfigFrom.controls['contact_number'].errors" defaultCountry="US">
                    </app-phone-number-input>
                    </div>
                
                    <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Contact Email
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" TrimText formControlName="contact_email" id="contact_email" name="contact_email"
                    placeholder="Enter Your Contact Email" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','contact_email') ">Contact Email is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.controls['contact_email'].value!='' && companyconfigFrom.controls['contact_email'].hasError('pattern') ">Enter valid email
                    </span>
                     </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">Line Of Business
                    </label>
                         <ng-select  placeholder="Select" [multiple]="true"   formControlName="lob_ids" name="lob_ids" id="lob_ids"
                                class="transcribeClass">
                                    @for (lob of lobListData; track lob.id) {
                                        <ng-option [value]="lob.id">{{lob.lob_name}}</ng-option>
                                    }
                                </ng-select>
                                  <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','lob_ids') ">Line Of Business is
                    required.
                    </span>
                  </div>
                  <div class="col">
                    <label for="topic" class="form-label mandatoryLabel">SIC Code
                     </label>
                         <ng-select  placeholder="Select" [multiple]="true"   formControlName="sic_ids" name="sic_ids" id="sic_ids"
                                class="transcribeClass">
                                    @for (sic of sicListData; track sic.id) {
                                        <ng-option [value]="sic.id">{{sic.sic_code}}</ng-option>
                                    }
                                </ng-select>
                                      <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','sic_ids') ">SIC Code is
                    required.
                    </span>
                  </div>
                </div>
                <div class="row">
                   <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active">Active</label>
                                            <input class="form-check-input" type="checkbox" formControlName="is_active"
                                            name="is_active" id="active">
                                        </div>
                                         <span class="text-danger"
                    *ngIf="submitted && companyconfigFrom.hasError('required','is_active')">Company active is
                    required.
                    </span>
                    </div>
                  </div>

                </form>
        </div>
     </ng-container>
     <ng-container *ngIf="seletedModal=='relationship'">
        <div class="col">
                <form class="companyconfigFrom" [formGroup]="relationshipconfigFrom" autocomplete="off">
         
                <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Relationship Type
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" TrimText formControlName="relationship_name" id="relationship_name" name="relationship_name"
                    placeholder="Enter Relationship Type" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.hasError('required','relationship_name') ">Relationship Type is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.controls['relationship_name'].value!='' && relationshipconfigFrom.controls['relationship_name'].hasError('pattern') ">
                    Invalid input: Only special characters (space, &, -) are allowed.
                    </span>
                    </div>
                   
                </div>
                <div class="row"> 
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Description
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                   <div class="col">
                      
             
                    
                 <textarea class="form-control" TrimText formControlName="description" id="description" name="description"></textarea>
                    <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.hasError('required','description') ">Description is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.controls['description'].value !='' && relationshipconfigFrom.controls['description'].hasError('pattern')">
                    Invalid input: Only special characters (space, &, -, .) are allowed.
                    </span>
                    </div>
                </div>
               
            
                
                 
                
                
                <div class="row">
                   <div class="col-3">  <label  class="form-label mandatoryLabel">Active
                     </label></div>
                   <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active"></label>
                                            <input class="form-check-input" type="checkbox" formControlName="is_active"
                                            name="is_active" id="active">
                                        </div>
                                         <span class="text-danger"
                    *ngIf="submitted && relationshipconfigFrom.hasError('required','is_active')">Status is
                    required.
                    </span>
                    </div>
                  </div>

                </form>
            </div>
     </ng-container>
     <ng-container *ngIf="seletedModal=='lob'">
           <div class="col">
                <form class="companyconfigFrom" [formGroup]="lobconfigFrom" autocomplete="off">
         
                <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Name
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" TrimText formControlName="lob_name" id="lob_name" name="lob_name"
                    placeholder="Enter LOB Name" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.hasError('required','lob_name') ">Name is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.controls['lob_name'].value!='' && lobconfigFrom.controls['lob_name'].hasError('pattern') ">
                    Invalid input: Only special characters (space, &) are allowed.
                    </span>
                    </div>
                   
                </div>
                <div class="row"> 
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Description
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                   <div class="col">
                      
             
                    
                 <textarea class="form-control" TrimText formControlName="description" id="description" name="description"></textarea>
                    <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.hasError('required','description') ">Description is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.controls['description'].value !='' && lobconfigFrom.controls['description'].hasError('pattern')">
                    Invalid input: Only special characters (space, &, -, .) are allowed.
                    </span>
                    </div>
                </div>
               
            
                
                 
                
                
                <div class="row">
                   <div class="col-3">  <label  class="form-label mandatoryLabel">Active
                     </label></div>
                   <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active"></label>
                                            <input class="form-check-input" type="checkbox" formControlName="is_active"
                                            name="is_active" id="active">
                                        </div>
                                         <span class="text-danger"
                    *ngIf="submitted && lobconfigFrom.hasError('required','is_active')">Status is
                    required.
                    </span>
                    </div>
                  </div>

                </form>
            </div>
     </ng-container>
     <ng-container *ngIf="seletedModal=='sic'">
        <div class="col">
                <form class="companyconfigFrom" [formGroup]="sicCodeconfigFrom" autocomplete="off">
         
              
                <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Title
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" TrimText formControlName="sic_title" id="sic_title" name="sic_title"
                    placeholder="Enter Title" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','sic_title') ">Title is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.controls['sic_title'].value!='' && sicCodeconfigFrom.controls['sic_title'].hasError('pattern') ">
                    Invalid input: Only special characters (space, &, -) are allowed.
                    </span>
                    </div>
                   
                </div>
                  <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">SIC Code
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" TrimText formControlName="sic_code" id="sic_code" name="sic_code"
                    placeholder="Enter SIC Code" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','sic_code') ">SIC Code is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.controls['sic_code'].value!='' && sicCodeconfigFrom.controls['sic_code'].hasError('pattern') ">
                     Numbers only allowed.
                    </span>
                    </div>
                   
                </div>
                 <div class="row">
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">SIC Office
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                  <div class="col">
                   
                    <input type="text" class="form-control" TrimText formControlName="sic_office" id="sic_office" name="sic_office"
                    placeholder="Enter Office" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','sic_office') ">SIC Office is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.controls['sic_office'].value!='' && sicCodeconfigFrom.controls['sic_office'].hasError('pattern') ">
                     Invalid input: Only special characters (space, &, -) are allowed.
                    </span>
                    </div>
                   
                </div>
                <div class="row"> 
                   <div class="col-3">
                  <label for="topic" class="form-label mandatoryLabel">Description
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label></div>
                   <div class="col">
                      
             
                    
                 <textarea class="form-control" TrimText formControlName="description" id="description" name="description"></textarea>
                    <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','description') ">Description is
                    required.
                    </span>
                      <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.controls['description'].value !='' && sicCodeconfigFrom.controls['description'].hasError('pattern')">
                    Invalid input: Only special characters (space, &, comma) are allowed.
                    </span>
                    </div>
                </div>
               
            
                
                 
                
                
                <div class="row">
                   <div class="col-3">  <label  class="form-label mandatoryLabel">Active
                     </label></div>
                   <div class="col">
                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active"></label>
                                            <input class="form-check-input" type="checkbox" formControlName="is_active"
                                            name="is_active" id="active">
                                        </div>
                                         <span class="text-danger"
                    *ngIf="submitted && sicCodeconfigFrom.hasError('required','is_active')">Status is
                    required.
                    </span>
                    </div>
                  </div>

                </form>
            </div>
     </ng-container>
  </div>
  <div modal-footer class="modal-footer">
     <ng-container *ngIf="seletedModal=='company'">
            <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveCompany()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateCompany()">Update</button>
                </ng-container>
            </div>
      </ng-container>
      <ng-container *ngIf="seletedModal=='relationship'">
             <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveRelationship()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateRelationshipForm()">Update</button>
                </ng-container>
            </div>
      </ng-container> 
      <ng-container *ngIf="seletedModal=='lob'">
           <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveLOB()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateLOB()">Update</button>
                </ng-container>
            </div>
      </ng-container>     
      <ng-container *ngIf="seletedModal=='sic'">
          <div class="form-group topicBtnGroup">
                <ng-container>
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button   *ngIf="!showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="saveSICCode()">Save</button>
                <button   *ngIf="showUpdateButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateSICCode()">Update</button>
                </ng-container>
            </div>
      </ng-container>
  </div>
</app-dialog-modal>